import { collection, onSnapshot, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../firebase/client";
import type { AuthorBroadcast } from "../types/broadcasts.types";

export function useAuthorBroadcasts(userId: string | null) {
	const [broadcasts, setBroadcasts] = useState<AuthorBroadcast[]>([]);

	useEffect(() => {
		if (!userId) return;

		const q = query(collection(db, "broadcasts"), where("userId", "==", userId));
		return onSnapshot(q, (snapshot) => {
			setBroadcasts(
				snapshot.docs.map((doc) => ({
					id: doc.id,
					...(doc.data() as Omit<AuthorBroadcast, "id">),
				})),
			);
		});
	}, [userId]);

	const live = broadcasts.filter((b) => b.status === "live");
	const history = broadcasts
		.filter((b) => b.status === "ended")
		.sort((a, b) => (b.endedAt ?? "").localeCompare(a.endedAt ?? ""));

	return { live, history };
}
